import React from 'react';
import { connect } from 'react-redux';
import { t } from '@lingui/macro';
import { onChangeMapFilters } from '../../ac/onChangeMapFilters';
import { withDisplayedLayersCheck } from '../../HOC/withDisplayedLayersCheck';
import { MapTimeline } from './MapTimeline';

/**
 * Привязка MapTimeline к слою «Агрегированные поездки (август)».
 *
 * Год выбирается прямо на таймлайне (categorical-домен), степпер в шапке не нужен.
 * Список лет — тот же, что у радиокнопок сайдбара (AggTripsAugustH3Filter).
 *
 * Состояние — mapFilters.aggTripsAugustYear (строка 'YYYY'). Перезапрос тайлов с
 * новым годом делает существующая логика Map.jsx по смене mapFilters.
 *
 * Монтируется только когда слой активен (withDisplayedLayersCheck).
 */

// Те же годы, что у сайдбара; на таймлайне — по возрастанию
const YEARS = [ 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026 ];
const AggTripsAugustYearTimelineComponent = ({ year, setYear }) => {
    const domain = React.useMemo(() => ({
        type: 'categorical',
        values: YEARS.map(y => ({ value: y, label: String(y) })),
        format: y => String(y),
    }), []);
    // Фолбэк — последний доступный год
    const cursor = year ? Number(year) : YEARS[YEARS.length - 1];
    const onCursorChange = y => {
        const next = String(y);
        if (next !== String(year)) setYear(next);
    };

    return (
        <MapTimeline
            domain={domain}
            cursor={cursor}
            onCursorChange={onCursorChange}
        />
    );
};
const mapStateToProps = ({ mapFilters: { aggTripsAugustYear } }) => ({ year: aggTripsAugustYear });
const mapDispatchToProps = dispatch => ({
    setYear: value => dispatch(onChangeMapFilters('aggTripsAugustYear', value)),
});
const ConnectedComponent = connect(mapStateToProps, mapDispatchToProps)(AggTripsAugustYearTimelineComponent);

export const AggTripsAugustYearTimeline = withDisplayedLayersCheck(
    ConnectedComponent,
    t`Агрегированные поездки (август)`
);
